import { getSystems } from "@/api/SyncSystem.js";
import {
  getAlerts as getAlertsApi,
  getMarketplaces as getMarketplacesApi,
  getFlagsHistory as getFlagsHistoryApi,
  getOrderStatusList as getOrderStatusListApi,
  getSellers as getSellersApi
} from "@/api/GeneralData";
import { getDepartamentos as getDepartmentsApi } from "@/api/Infoauto";
export const state = {
  getAppVersion: require("../../../package.json").version,
  showMenu: true,
  systems: [],
  alerts: [],
  marketplaces: [],
  flagsHistory: [],
  orderStatusList: [],
  sellers: [],
  departments: []
};

export const getters = {
  getStatusMenu(state) {
    return state.showMenu;
  },
  getDepartments(state) {
    return state.departments;
  },
  getSystems(state) {
    return state.systems;
  },
  getAlerts(state) {
    return state.alerts;
  },
  getMarketplaces(state) {
    return state.marketplaces;
  },
  getFlagsHistory(state) {
    return state.flagsHistory;
  },
  getOrderStatusList(state) {
    return state.orderStatusList;
  },
  getSellers(state) {
    return state.sellers;
  },
  getAppVersion(state) {
    return state.getAppVersion;
  }
};

export const mutations = {
  UPDATE_MENU(state, newStatus) {
    state.showMenu = newStatus;
  },
  UPDATE_SYSTEMS(state, systems) {
    state.systems = systems;
  },
  UPDATE_ALERTS(state, alerts) {
    state.alerts = alerts;
  },
  UPDATE_MARKETPLACES(state, marketplaces) {
    state.marketplaces = asList(marketplaces);
  },
  UPDATE_FLAGS_HISTORY(state, flagsHistory) {
    state.flagsHistory = asList(flagsHistory);
  },
  UPDATE_ORDER_STATUS_LIST(state, orderStatusList) {
    state.orderStatusList = asList(orderStatusList);
  },
  UPDATE_SELLERS(state, sellers) {
    state.sellers = asList(sellers);
  },
  UPDATE_DEPARTMENTS(state, departments) {
    state.departments = asList(departments);
  }
};

export const actions = {
  init({ commit, dispatch }) {
    // getAlertsApi()
    //   .then(response => {
    //     console.log(response);
    //   })
    //   .catch(() => {
    //     console.log("api error");
    //   });
    // Devuelve la promesa para que el login espere estos datos antes de navegar
    return Promise.all([
      getMarketplacesApi()
        .then(response => {
          commit("UPDATE_MARKETPLACES", response);
        })
        .catch(() => {
          console.log("api error");
        }),
      dispatch("updateFlagsHistory"),
      dispatch("updateOrderStatusList"),
      dispatch("updateSellers"),
      dispatch("loadDepartments")
    ]);
  },
  async updateSystems({ commit }) {
    let systems = await getSystems();
    commit("UPDATE_SYSTEMS", systems);
  },
  updateShowMenu({ commit }, newStatus) {
    commit("UPDATE_MENU", newStatus);
  },
  updateAlerts({ commit }) {
    getAlertsApi()
      .then(response => {
        commit("UPDATE_ALERTS", response);
      })
      .catch(e => {
        console.log(e);
      });
  },
  updateFlagsHistory({ commit }) {
    return getFlagsHistoryApi()
      .then(flagsHistory => {
        commit("UPDATE_FLAGS_HISTORY", flagsHistory);
      })
      .catch(() => {
        this.$toast.error("Error fetching flags history");
      });
  },
  updateOrderStatusList({ commit }) {
    return getOrderStatusListApi()
      .then(orderStatusList => {
        commit("UPDATE_ORDER_STATUS_LIST", orderStatusList);
      })
      .catch(() => {
        this.$toast.error("Error fetching order status list");
      });
  },
  updateSellers({ commit }) {
    return getSellersApi()
      .then(sellers => {
        commit("UPDATE_SELLERS", sellers);
      })
      .catch(() => {
        this.$toast.error("Error fetching sellers");
      });
  },
  loadDepartments({ commit }) {
    return getDepartmentsApi()
      .then(departments => {
        commit("UPDATE_DEPARTMENTS", departments);
      })
      .catch(() => {
        this.$toast.error("Error fetching departments");
      });
  }
};

// Con un 401 el interceptor de http.js resuelve con false en vez de fallar, y
// res.data queda undefined: el menu y los listados esperan siempre una lista.
function asList(value) {
  return Array.isArray(value) ? value : [];
}
